<template>
	<div>
        <Loading :value="loading" ></Loading>
        <v-dialog v-model="dialogRapportDepannage" max-width="70%" :persistent="true" transition="dialog-bottom-transition" scrollable
                  >
            <v-card tile>
                <v-toolbar card dark color="primary">

                    <v-toolbar-title>Raaport de depannage Demande DMD-{{demandeDetail.idDemande}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="closeDialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-alert :value="true" outline color="purple" icon="info">
                                Ajouter des images
                            </v-alert>

                             <el-form id="formRapport2" ref="formRapport2"  style="width:100%"   :model="formRapport"   class="demo-form-inline" >
                              <v-layout row >
                                     <v-flex xs6 >
                                         <v-layout row>
                                        <v-flex xs3 class="mr-2" >
                                            <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="image1" alt="avatar"></v-avatar>
                                            <v-layout row>
                                                <input name="image1" type="file" style="display:none" ref="file1" accept="image/*" @change="onFileImage1Picked"/>
                                                    <v-btn color="primary" class="white--text" required @click.native="$refs.file1.click()">Photo  <v-icon right dark>cloud_upload</v-icon></v-btn>
                                                    <div class="font-weight-thin" >Fichier au format (JPEG,PNG,PDF) avec une taille de 1048 ko maximale</div>
                                            </v-layout>
                                        </v-flex>

                                        <!-- <v-flex xs3 class="mr-3" >
                                            <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="image2" alt="avatar"></v-avatar>
                                            <v-layout row>
                                                <input name="image2" type="file" style="display:none" ref="file2" accept="image/*" @change="onFileImage2Picked"/>
                                                    <v-btn color="primary" class="white--text" required @click.native="$refs.file2.click()">Photo  <v-icon right dark>cloud_upload</v-icon></v-btn>
                                            </v-layout>
                                        </v-flex>

                                        <v-flex xs3 class="mr-3" >
                                            <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="image3" alt="avatar"></v-avatar>
                                            <v-layout row>
                                                <input name="image3" type="file" style="display:none" ref="file3" accept="image/*" @change="onFileImage3Picked"/>
                                                    <v-btn color="primary" class="white--text" required @click.native="$refs.file3.click()">Photo  <v-icon right dark>cloud_upload</v-icon></v-btn>
                                            </v-layout>
                                        </v-flex> -->
                                    </v-layout>
                                </v-flex>


                                    <v-flex xs6 >
                                         <el-form-item style="width:100%" label="Rapport de depannage" >
                                        <el-input
                                            type="textarea"
                                            :rows="4"
                                            placeholder="Rapport de depannage"
                                            v-model="formRapport.rapport">
                                        </el-input>
                                         </el-form-item >
                                    </v-flex>
                              </v-layout>
                              </el-form>

                        </v-flex>

                        <!-- bouton validation -->
                                    <v-flex xs12 class="text-xs-right"   >
                                        <v-btn icons dark color="green" @click="submitFormRapport()">Enregistrer<v-icon right>add</v-icon></v-btn>
                                    </v-flex>
                                    <!-- bouton validation -->

                    </v-layout>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

	</div>
</template>


<script>
    import Loading from '@/components/Loading'
    export default {
	components:{ Loading },
        name: "RapportDepannage",
        props:["show","demandeDetail"],
        data()
        {
         return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),

            loading: false,
            dialogRapportDepannage: false,
            formRapport: {},
            dialogImageUrl: '',
            dialogVisible: false,
            fileList: [],
            //image
            image1: "/static/img-doc.png",
            image2: "/static/img-doc.png",
            image3: "/static/img-doc.png",
            image4: "/static/img-doc.png",
            file1: "",
            file2: "",
            file3: "",


         }
        },

        computed:{

        },
         watch: {
            show : function(newValue, oldvalue){
               this.dialogRapportDepannage = newValue
            }
        },

        methods: {
             closeDialog(){
                this.$emit('close')
            },
             handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handleSuccess(response, file, fileList){
                 console.log("succeess");
                  console.log(response, file, fileList);
                    this.fileList.push(file)

            },
            handlePictureCardPreview(file, fileList) {
                 console.log(file, fileList);
                this.dialogImageUrl = file.url;

                this.dialogVisible = true;
            },
            submitFormRapport()
            {
                this.loading = true
                let url = this.domaine + 'demande_maintenance/rapport/depannage'

                let form = document.getElementById('formRapport2')
                let data = new FormData(form)
                data.append("idDemande",this.demandeDetail.idDemande)
                data.append("rapport",this.formRapport.rapport)
                this.$http.post(url, data).then(response => {
                     this.closeDialog()
                     this.image1 = "/static/img-doc.png",
                      this.image2 = "/static/img-doc.png",
                      this.image3 = "/static/img-doc.png",
                      this.image = "/static/img-doc.png",
                      this.file1 = "",
                      this.file2 = "",
                      this.file3 = "",
                     this.loading = false
                    if(response.body.code == 5)
                    {
                      this.successNotif(response.body.message,"error")
                    }else{
                        this.successNotif(response.body.message)
                    }

                  },(erreurRep) => {
                    this.$message.error("Une erreur est survenue lors de l'enregistrement du rapport de depannage")
                })
            },

            successNotif(mess = "Rapport enregistrée avec succès",type = "success"){
            this.$notify({
                    title: 'ENREGISTREMENT RAPPORT',
                    message: mess,
                    type: type,
                    position: 'top-center',
                    duration: 5000
            })
            },
            //enregistrement des images
        onFileImage1Picked(event)
            {
                const files = event.target.files
                let filename = files[0].name
                if (filename.lastIndexOf(".") <= 0)
                {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }

                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                    this.image1 = fileReader.result
                })

                fileReader.readAsDataURL(files[0])
                this.file1 = files[0]
            },
         //enregistrement des images
        onFileImage2Picked(event)
            {
                const files = event.target.files
                let filename = files[0].name
                if (filename.lastIndexOf(".") <= 0)
                {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }

                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                    this.image2 = fileReader.result
                })

                fileReader.readAsDataURL(files[0])
                this.file2 = files[0]
            },

         //enregistrement des images
        onFileImage3Picked(event)
            {
                const files = event.target.files
                let filename = files[0].name
                if (filename.lastIndexOf(".") <= 0)
                {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }

                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                    this.image3 = fileReader.result
                })

                fileReader.readAsDataURL(files[0])
                this.file3 = files[0]
            }
        },
        mounted(){

        }

    }
    </script>



// WEBPACK FOOTER //
// src/components/maintenance/RapportDepannage.vue